









import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import { GET_ANSWER_BY_ID, SET_OPEN_ANSWER } from "@/store/types";
export default Vue.extend({
  name: "OpenQuestion",

  props: {
    question: {
      type: Object,
      required: true
    }
  },

  components: {
    TextareaGroup: () => import("@/components/Form/TextareaGroup.vue")
  },

  computed: {
    ...mapGetters({
      getAnswerById: GET_ANSWER_BY_ID
    }),

    openQuestion: {
      get(): string {
        const answer = this.getAnswerById(this.question.id);
        return answer ? answer.openAnswer : "";
      },
      set(openAnswer): void {
        const { id } = this.question;
        this.setOpenAnswer({ id, openAnswer });
      }
    }
  },

  methods: {
    ...mapMutations({
      setOpenAnswer: SET_OPEN_ANSWER
    })
  }
});
